import { render, staticRenderFns } from "./AppLayoutBodyPanelArea.vue?vue&type=template&id=2c0d4afa&"
import script from "./AppLayoutBodyPanelArea.vue?vue&type=script&lang=ts&"
export * from "./AppLayoutBodyPanelArea.vue?vue&type=script&lang=ts&"
import style0 from "./AppLayoutBodyPanelArea.vue?vue&type=style&index=0&id=2c0d4afa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports